import { render, staticRenderFns } from "./EventTypeEditor.vue?vue&type=template&id=82f896d2"
import script from "./EventTypeEditor.vue?vue&type=script&lang=js"
export * from "./EventTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports